<div class="container" [class.firm-mode]="isFirm">
  <mat-icon [mat-dialog-close]="false" id="close">close</mat-icon>
  <div class="title">
    <span i18n="@@DocumentPreview">Document Preview</span>
  </div>

  <div class="toolbar">
    <div class="nav-bar" *ngIf="files.length > 1">
      <button mat-icon-button (click)="navigate(-1)" [disabled]="currentIndex === 0 || loading">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="nav-label">{{ currentFile?.filename || ('File ' + (currentIndex + 1)) }} ({{ currentIndex + 1 }} / {{ files.length }})</span>
      <button mat-icon-button (click)="navigate(1)" [disabled]="currentIndex === files.length - 1 || loading">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <div class="zoom-bar" *ngIf="isReady">
      <button mat-icon-button (click)="zoomOut()" [disabled]="zoom <= minZoom" [matTooltip]="'ZoomOut' | translate" data-testid="document-preview-zoom-out">
        <mat-icon>remove</mat-icon>
      </button>
      <span class="zoom-label" (click)="resetZoom()" [matTooltip]="'ResetZoom' | translate" data-testid="document-preview-zoom-reset">{{ (zoom * 100) | number:'1.0-0' }}%</span>
      <button mat-icon-button (click)="zoomIn()" [disabled]="zoom >= maxZoom" [matTooltip]="'ZoomIn' | translate" data-testid="document-preview-zoom-in">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-icon-button *ngIf="extension !== 'pdf'" (click)="rotateRight()" [matTooltip]="'Rotate' | translate" data-testid="document-preview-rotate">
        <mat-icon>rotate_right</mat-icon>
      </button>
    </div>
  </div>

  <div class="loading-state" *ngIf="loading">
    <span>Loading document...</span>
  </div>

  <div class="loading-state" *ngIf="loadError && !loading">
    <span>{{ errorMessage || 'Could not load document.' }}</span>
  </div>

  <ng-container *ngIf="isReady">
    <ng-container *ngIf="extension === 'pdf'">
      <div class="content" (wheel)="onWheel($event)" (contextmenu)="isFirm && $event.preventDefault()">
        <div class="confidential" *ngIf="isConfidential">
          <div class="watermark" *ngFor="let _ of watermarkCells">
            <h1>Confidential</h1>
            <p>{{ legalName }} {{ documentId }}</p>
          </div>
        </div>
        <div class="transform-wrapper" [class.dragging]="isDragging" [style.transform]="contentTransform" (mousedown)="onMouseDown($event)">
          <pdf-viewer
            [src]="pdfData!"
            [original-size]="false"
            [render-text]="true"
            [show-all]="true"
            [fit-to-page]="false"
            [zoom]="zoom"
            [zoom-scale]="'page-width'"
            [stick-to-page]="true"
            [external-link-target]="'blank'"
            [autoresize]="true"
            [show-borders]="false"
            class="pdf-viewer"
          ></pdf-viewer>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="extension !== 'pdf'">
      <div class="content" (wheel)="onWheel($event)" (contextmenu)="isFirm && $event.preventDefault()">
        <div class="confidential" *ngIf="isConfidential">
          <div class="watermark" *ngFor="let _ of watermarkCells">
            <h1>Confidential</h1>
            <p>{{ legalName }} {{ documentId }}</p>
          </div>
        </div>
        <div class="transform-wrapper" [class.dragging]="isDragging" [style.transform]="contentTransform" (mousedown)="onMouseDown($event)">
          <img [src]="imageUrl" alt="" />
        </div>
      </div>
    </ng-container>
  </ng-container>

  <button class="close-btn" [mat-dialog-close]="false" mat-button="">CLOSE WINDOW</button>
</div>
